$body = $(".section__wrapper");
  
  
  $(document).on('change','input[name="dataCheck"]',function() {
    
    $body.addClass("data-check-loading");
    
    var properties = $(this).data('properties');
        var item_qty =  $(this).data('item-qty');
    
    if (this.checked) {
      console.log(properties);
      
      let formData = {
        'items': [{
          'id': datencheck_product_variant_id,
          'quantity': 1,
          properties: {
            '_ParentProduct': $(this).data('parent_product_id')
          }
        }]
      };
      var added_product_key = '';
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + 'cart/add.js',
        data: JSON.stringify(formData),
        contentType: "application/json",
        async : false,
        dataType: "json",
        success: function (response) {
          added_product_key = response.items[0].key;
        },
        failure: function (response) {
          console.log(response);
        }
      });
      var properties_str = '{'
      properties.forEach(function(value){
        
        properties_str+= '"'+value[0] + '":"' + value[1]+'", ';
        
      });
      properties_str+='"_dataCheck":1,';
      properties_str+='"_added_product_key":"'+added_product_key+'"}';
      
    } else {
      
      
      
      var remove_product_key = '';
      var properties_str = '{'
      properties.forEach(function(value){
        
        if(value[0] == '_dataCheck' || value[0] == '_added_product_key') {
          if(value[0] == '_added_product_key'){
               
		 		remove_product_key = value[1];
            }
         
           } else {
             properties_str+= '"'+value[0] + '":"' + value[1]+'",';
             
          }	
      });
      
      properties_str = properties_str.slice(0, -1); 
      properties_str+='}';
      
      
      let formData = {
        'updates': {
          [remove_product_key]: 0
        }
      };
      
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + 'cart/update.js',
        data: JSON.stringify(formData),
        contentType: "application/json",
        async : false,
        dataType: "json",
        success: function (response) {
          added_product_key = response.items[0].key;
        },
        failure: function (response) {
          console.log(response);
        }
      });
      
      $('#personalisiert-money').contents().filter((_, el) => el.nodeType === 3).remove();
  
      
      
    }
    
    var properties_new = JSON.parse(properties_str);
    
//     alert(item_qty);
   
    
    let changeParentProduct = {
      id: $(this).data('parent_product_id'),
      properties: properties_new,
      'quantity': item_qty
      
    };

    
    $.ajax({
      type: "POST",
      url: window.Shopify.routes.root + 'cart/change.js',
      data: JSON.stringify(changeParentProduct),
      contentType: "application/json",
      dataType: "json",
      beforeSend: function(x) {
        if (x && x.overrideMimeType) {
          x.overrideMimeType("application/j-son;charset=UTF-8");
        }
      },
      success: function (response) {
//             Shopify.theme.jsCart.updateView(response);
        //update_draft_cart(response);
            //location.reload();
        location.reload(true);


          },
          failure: function (response) {
            console.log(response);
          },complete: function(){
        	$body.removeClass("data-check-loading");
        }
        });
   
  });

$(document).on('click','.close-datacheck',function(){
  var properties = $(this).data('properties');
  var remove_parent_product_key = $(this).data('parent_product_key').replace(new RegExp('"', 'g'),"")
  var remove_product_key = '';
      var properties_str = '{'
      properties.forEach(function(value){
        if(value[0] == '_added_product_key') {
		 		remove_product_key = value[1];
           } 
      });
      
      properties_str = properties_str.slice(0, -1); 
      properties_str+='}';    
      let formData = {
        'updates': {
          [remove_product_key]: 0,
          [remove_parent_product_key]: 0
        }
      };

      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + 'cart/update.js',
        data: JSON.stringify(formData),
        contentType: "application/json",
        async : false,
        dataType: "json",
        success: function (response) {
//           Shopify.theme.jsCart.updateView(response);
           location.reload();
        },
        failure: function (response) {
          console.log(response);
        }
      });
    }); 

